import api from '../api';
import secureStorage from '../../utils/SecureStorage';

const BuscarSuporte = async () => {
  const apiUrl = process.env.REACT_APP_API_BASE_75; // Certifique-se de que esta variável está definida corretamente
  const idRede = secureStorage.getItem("id_r") || "";

  try {
    const response = await api.get(`${apiUrl}?id_rede=${idRede}`); // Faz a requisição à API

    if (response.data && Array.isArray(response.data.cadastros)) {
      // Verifica se o campo "cadastros" existe e é um array
      secureStorage.setItem("datarede", JSON.stringify(response.data.cadastros));
      return response.data.cadastros;
    } else {
      console.warn("Nenhum cadastro encontrado ou formato inválido.");
      return secureStorage.getItem("datarede") ? JSON.parse(secureStorage.getItem("datarede")) : [];
    }
  } catch (error) {
    console.error("Erro ao buscar cadastros:", error.message);
    throw new Error("Erro ao buscar cadastros da API."); // Lança um erro para tratamento externo
  }
};

export default BuscarSuporte;
